/*
 * Bridge between the API layer and the active auth method: the axios
 * client reports 401 responses here, the auth provider registers what
 * to do about them (renew the token or drop the session and thereby
 * redirect to the login page).
 */
let sessionExpiredHandler = null;

export const setSessionExpiredHandler = (handler) => {
  sessionExpiredHandler = handler;
};

export const notifySessionExpired = () => {
  sessionExpiredHandler?.();
};
